import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import PpcOverTimePortfolios from './components/Page';

const PpcOverTimePortfoliosPage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">PPC Over Time Portfolios</h3>
      </Col>
    </Row>
    <Row>
      <PpcOverTimePortfolios />
    </Row>
  </Container>
);

export default PpcOverTimePortfoliosPage;
